import {
  compose,
  renameProp,
  withHandlers,
  withProps,
  defaultProps,
} from 'recompose'
import * as R from 'ramda'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

const enhance = compose(
  defaultProps({
    onChange: R.identity,
  }),
  renameProp('onChange', 'onChangeCallback'),
  toReduxFormField('InputSelect'),
  withProps(props => {
    // CARE-1334 - always sort the options in ascending order. We discussed
    // who should sort this data with the BE team and because data sometimes comes
    // from third parties like ScriptSave, and because we may decide to change
    // what to sort by in the future (something different from the label), so
    // it was decided that the FE should do this sorting for this one use case.
    const sortedOptions = props.options.sort((a, b) => {
      return a.value?.toString().localeCompare(b.value?.toString(), undefined, {
        numeric: true,
        sensitivity: 'base',
      })
    })
    // We have to use defineProperty to set the property because
    // otherwise it will throw a read-only error.
    Object.defineProperty(props, 'options', sortedOptions)
  }),
  withHandlers({
    handleChange:
      ({ input: { onChange }, onChangeCallback }) =>
      value => {
        onChange(value)
        onChangeCallback(value)
      },
  }),
)

export default enhance
